/* eslint-disable prettier/prettier */
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Vuex from "vuex";
import nearcodeService from "../api/nearcodeService";

Vue.use(Vuex);
Vue.use(VueSweetalert2)

export default new Vuex.Store({
  state: {
    noJobs: "Neste momento não existem vagas de emprego!",
    jobs: [],
    skills: [],
    content: [],
    message: "",
    submessage: ""
  },
  mutations: {
    SET_JOBS(state, data) {
      state.jobs = data;
    },
    ADD_APPLICATION(state, data) {
      state.message = data.message
      state.submessage = data.submessage
    },
    SET_SKILLS(state, data) {
      state.skills = data
    },
    ADD_SPONTANEOUS_APPLICATION(state, data) {
      state.message = data.message
      state.submessage = data.submessage
    },
    SET_CONTENT(state, data) {
      state.content = data
    },
    SEND_EMAIL() {}
  },
  actions: {
    async fetchJobs({
      commit
    }) {
      commit("SET_JOBS", await nearcodeService.getJobs())
    },
    async fetchApplications({
      commit
    }, payload) {
      commit("ADD_APPLICATION", await nearcodeService.addApplication(payload.idJobs, payload.name, payload.email, payload.cv, payload.linkedin, payload.skills, payload.about, payload.otherSkills, payload.cellphone))
    },
    async fetchSkills({
      commit
    }) {
      commit("SET_SKILLS", await nearcodeService.getSkills())
    },
    async postSpontaneousApplication({
      commit
    }, payload) {
      commit("ADD_SPONTANEOUS_APPLICATION", await nearcodeService.spontaneousApplication(payload.name, payload.email, payload.cv, payload.linkedin, payload.skills, payload.about, payload.otherSkills, payload.cellphone))
    },
    async fetchContent({
      commit
    }) {
      commit("SET_CONTENT", await nearcodeService.getContent())
    },
    async sendEmail({
      commit
    }, payload) {
      commit("SEND_EMAIL", await nearcodeService.sendEmail(payload.name, payload.email, payload.message))
    },
  },
  getters: {
    getJobs: state => state.jobs,
    getSkills: state => state.skills,
    getContent: state => state.content,
    getNoJobs: state => state.noJobs,
    getMessage: state => state.message,
    getSubmessage: state => state.submessage
  },
  modules: {}
});